import { render, staticRenderFns } from "./AdminTeacherListGrid.vue?vue&type=template&id=523b737e"
import script from "./AdminTeacherListGrid.vue?vue&type=script&lang=js"
export * from "./AdminTeacherListGrid.vue?vue&type=script&lang=js"
import style0 from "./AdminTeacherListGrid.vue?vue&type=style&index=0&id=523b737e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports